import { Button, Link, Loader } from '@ets-global/b2c-website-ui';
import { List as ImmutableList } from 'immutable';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import useGlobalDocuments from '../../../../hooks/useGlobalDocuments';
import Item from './Item';
import SessionSearchItemSkeleton from './Item/SessionSearchItemSkeleton';

const List = ({
  inMap = false,
  sessions = [],
  skeleton = false,
  withDisabilityMessage = true,
  showLoadMore = true,
  onLoadMore = () => {},
  loadMoreProps = {},
  isEproctored = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [isRegisterButtonClicked, setRegisterButtonClicked] = useState(false);
  const { globalDocuments } = useGlobalDocuments();
  const { t } = useTranslation();

  const onClickMoreButton = (e) => {
    e.preventDefault();
    setLoading(true);
    onLoadMore().then(() => setLoading(false));
  };

  return (
    <div className="search-session-main__list search-session-main__list--active">
      {!skeleton && withDisabilityMessage && !isEproctored && (
        <div className="search-session-main__handicap">
          <h3 className="search-session-main__handicap-title">
            <strong className="search-session-main__handicap-title-bold">
              <Trans>session-search.main.handicap-title-strong</Trans>
            </strong>
            <Trans>session-search.main.handicap-title</Trans>
          </h3>
          <p className="search-session-main__handicap-paragraph">
            <Trans>session-search.main.handicap-paragraph</Trans>
          </p>
          {globalDocuments.testTakersWithDisabilitiesUrl && (
            <Link
              to={globalDocuments.testTakersWithDisabilitiesUrl}
              icon={'arrow'}
              aria-label={t('session-search.main.handicap-download.button')}
            >
              <Trans>session-search.main.handicap-download.button</Trans>
            </Link>
          )}
        </div>
      )}
      {skeleton && [...Array(4)].map((session, key) => <SessionSearchItemSkeleton key={key} inMap={inMap} />)}
      {!skeleton && (
        <Fragment>
          {sessions.map((session, key) => (
            <Item
              key={key}
              session={session}
              inMap={inMap}
              isRegisterButtonClicked={isRegisterButtonClicked}
              setRegisterButtonClicked={setRegisterButtonClicked}
            />
          ))}
          {showLoadMore && (
            <div className="search-session-main__more">
              {loading && <Loader />}
              <Button
                {...loadMoreProps}
                onClick={onClickMoreButton}
                disabled={loading}
                aria-label={t('session-search.main.load-more.button')}
              >
                <Trans>session-search.main.load-more.button</Trans>
              </Button>
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

List.propTypes = {
  inMap: PropTypes.bool,
  sessions: PropTypes.instanceOf(ImmutableList),
  skeleton: PropTypes.bool,
  withDisabilityMessage: PropTypes.bool,
  showLoadMore: PropTypes.bool,
  loadMoreProps: PropTypes.object,
  isEproctored: PropTypes.bool,
};

export default List;
